import DOMPurify from 'dompurify';
import { ModalBody, ModalDialog, ModalHeader, ModalOverlay } from '@flos/react-ui';
import { type ViewInformationModalProps } from '../../config/modalConfig';
import { useHippoText } from '../../hooks/useHippoText';

const ConditionsAndExclusionsModal = ({
    showModal,
    closeModal,
    modalProps
}: {
    showModal: boolean;
    closeModal: () => void;
    modalProps: ViewInformationModalProps;
}): React.JSX.Element => {
    const description = DOMPurify.sanitize(modalProps.description);
    const getHippoText = useHippoText();

    return (
        <ModalOverlay
            isOpen={showModal}
            onDismiss={() => {
                closeModal();
            }}
        >
            <ModalDialog
                closeIconHandler={() => {
                    closeModal();
                }}
            >
                <ModalHeader className="u-spacing-stack-sm">
                    <span>{getHippoText('DSS-SPECIAL-CONDITIONS-TITLE')}</span>
                    <h4>{modalProps.title}</h4>
                </ModalHeader>
                <ModalBody>
                    {
                        <div
                            className="u-spacing-stack-m"
                            dangerouslySetInnerHTML={{ __html: description }}
                        ></div>
                    }
                </ModalBody>
            </ModalDialog>
        </ModalOverlay>
    );
};

export default ConditionsAndExclusionsModal;
